var $171116fc883d9d7f$exports = {};
$171116fc883d9d7f$exports = {
    "alert": `Upozorenje`,
    "dismiss": `Odbaci`
};


export {$171116fc883d9d7f$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
